"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _NicheFormEngine = _interopRequireDefault(require("../../common/NicheFormEngine"));
var _nicheUserFeService = require("niche-user-fe-service");
var _uiSchema = require("./uiSchema");
var _schema = require("./schema");
var _antd = require("antd");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NicheSendOtp = props => {
  const [error, setError] = (0, _react.useState)("");
  const {
    token: {
      colorError
    }
  } = _antd.theme.useToken();
  const handleSendOtp = async data => {
    await (0, _nicheUserFeService.sendOtp)(props.url, data?.formData).then(response => {
      props.handleSubmit({
        ...response,
        phoneNumber: data?.formData?.phoneNumber
      });
    }).catch(err => {
      setError(err?.response?.data?.error || err?.response?.data?.message);
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        color: colorError
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: error
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NicheFormEngine.default, {
      schema: _schema.schema,
      uiSchema: _uiSchema.uiSchema,
      clearError: () => setError(""),
      handleSubmit: handleSendOtp
    })]
  });
};
var _default = exports.default = NicheSendOtp;